export const BLUEPRINT_TYPES = {
  tree: {
    label: 'Hierarchical tree',
    name: 'tree'
  },
  discrete: {
    label: 'Discrete',
    name: 'discrete'
  },
  discrete_multiple: {
    label: 'Discrete (multiple)',
    name: 'discrete_multiple'
  },
  likert: {
    label: 'Likert',
    name: 'likert'
  },
  string: {
    label: 'Free text (short)',
    name: 'string'
  },
  text: {
    label: 'Free text (long)',
    name: 'text'
  },
  date: {
    label: 'Date',
    name: 'date'
  },
  datetime: {
    label: 'DateTime',
    name: 'datetime'
  },
  numeric: {
    label: 'Numeric',
    name: 'numeric'
  },
  boolean: {
    label: 'Boolean',
    name: 'boolean'
  },
  file: {
    label: 'File',
    name: 'file'
  }
}
